import React from 'react';
import PropTypes from 'prop-types';
import DownloadIcon from '@material-ui/icons/CloudDownloadOutlined';
import SendToSecureFilesIcon from '@material-ui/icons/FolderSharedOutlined';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import classNames from 'classnames';
import { Box } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4';
import {
  AttachmentHoverMenuItem,
} from 'Components/ComponentLibrary/Components/Uncategorized/AttachmentsRebranded/AttachmentRebranded/components/AttachmentRebrandedHoverMenu/components/AttachmentHoverMenuItem';

const useStyles = buildUseStyles('HoverMenuRebranded', (theme) => ({
  root: {
    display: 'flex',
    gap: theme.spacing(1),
    margin: theme.spacing(0, 1),
  },
}));

const HoverMenuRebranded = ({
  className,
  onDownload,
  onSendToSecureFiles,
  sendingToSecureFiles,
  fileResource,
  isHovered,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [sentToSecureFiles, setSentToSecureFiles] = React.useState(false);

  if (!onDownload && !onSendToSecureFiles) {
    return null;
  }

  if (!isHovered) {
    return null;
  }

  const sendToSecureFiles = () => {
    onSendToSecureFiles()
      .then(() => setSentToSecureFiles(true));
  };

  return (
    <Box className={classNames(className, classes.root)}>
      <AttachmentHoverMenuItem
        isVisible={onDownload}
        toolTipTitle="Download"
        icon={DownloadIcon}
        onClick={onDownload}
        test={`hover-menu-download-button-${fileResource.link('self').url()}`}
      />
      <AttachmentHoverMenuItem
        isVisible={onSendToSecureFiles && !sentToSecureFiles}
        disabled={sendingToSecureFiles}
        toolTipTitle="Send to secure files"
        icon={SendToSecureFilesIcon}
        onClick={sendToSecureFiles}
        test={`hover-menu-send-to-secure-files-button-${fileResource.link('self').url()}`}
      />
    </Box>
  );
};

HoverMenuRebranded.defaultProps = {
  className: '',
  onSendToSecureFiles: null,
  onDownload: null,
  sendingToSecureFiles: false,
  isHovered: false,
};

HoverMenuRebranded.propTypes = {
  className: PropTypes.string,
  onSendToSecureFiles: PropTypes.func,
  onDownload: PropTypes.func,
  sendingToSecureFiles: PropTypes.func,
  fileResource: PropTypes.object.isRequired,
  isHovered: PropTypes.bool,
};

export { HoverMenuRebranded };
